<style scoped lang="less">
.avatar-uploader-icon {
	border: 1px dashed #d9d9d9 !important;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9 !important;
	border-radius: 6px !important;
	position: relative !important;
	overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
	border: 1px dashed #d9d9d9 !important;
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 300px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 300px;
	height: 178px;
	display: block;
}

.addinput {
	background: #fff;
	padding: 1rem;

	.radioszyqx {
		display: flex;
		label:last-child {
			border: none !important;
		}
		label {
			border: none !important;
		}
	}

	.addinputtop {
		width: 100%;
		height: 4rem;
		background: #fff;
		border-left: 4px solid #ffc107;
		padding: 0.7rem 0 0 1rem;
		margin-bottom: 1rem;
		box-sizing: border-box;

		p:first-child {
			font-size: 1.2rem;
			color: #333;
		}

		p:last-child {
			font-size: 0.8rem;
			color: #77818e;
		}
	}

	.addform {
		display: flex;
		justify-content: center;
		flex-direction: column;

		label:last-child {
			border-bottom: 1px solid #ccc;
		}

		label,
		.labelas {
			textarea {
				color: #333;
			}

			display: block;
			width: 100%;
			padding: 1rem 0;
			border-top: 1px solid #ccc;
			box-sizing: border-box;

			.labelchiles {
				margin: 0 auto;
				display: flex;
				align-items: center;

				p {
					// width: 5vw;
					text-align: right;
					margin-right: 1rem;
					color: rgb(74, 83, 94);
					font-size: 0.8rem;
				}
			}
		}
	}

	.fromsbtn {
		// width: 50%;
		margin: 1rem auto;
		display: flex;
		align-items: center;
		justify-content: center;

		button {
			margin: 0 1rem;
			padding: 0.6rem 2rem;
			border-radius: 2px;
			background-color: #f7f7f7;
			color: #333;
			border: 1px solid #ccc;
		}

		button:first-child {
			background-color: #3071a9;
			color: #fff;
		}

		button:hover {
			background-color: #1f92ea;
		}

		button:last-child:hover {
			background-color: #d9d9d9;
		}
	}
}
</style>
<template>
	<div>
		<titles titlename="上传资源" titlecontent="这里可以看到课程资源" :mbx="paths"></titles>
		<div class="addinput">
			<div class="addinputtop">
				<p>资源基本信息</p>
				<p>请填写资源基本信息，资源介绍信息</p>

				<div style="width: 400px;"><el-progress v-if="progressFlag" text-color="#fff" :text-inside="true" :percentage="loadProgress" :stroke-width="24"></el-progress></div>
			</div>

			<form class="addform">
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
							资源名称
							<span style="color: red;">*</span>
						</p>
						<input type="text" class="form-control" v-model="resourceobj.name" placeholder="请输入资源名称" />
					</div>
				</label>

				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
							所属专业
							<span style="color: red;">*</span>
						</p>
						<select v-model="resourceobj.ProfessionalID" class="form-control" id="exampleFormControlSelect1" @change="GetuserSelects()">
							<option value="">-- 请选择所属专业 --</option>
							<option v-for="(item, index) in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid">{{ item.pro_name }}</option>
						</select>
					</div>
				</label>

				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
							所属岗位
							<span style="color: red;">*</span>
						</p>
						<select v-model="resourceobj.PR_GUID" class="form-control" id="exampleFormControlSelect1">
							<option value="">-- 请选择所属岗位 --</option>
							<option v-for="(item, index) in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID">
								{{ item.PR_ProfessionalName }}
							</option>
						</select>
					</div>
				</label>

				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
							资源类型
							<span style="color: red;">*</span>
						</p>
						<select v-model="resourceobj.RT_GUID" class="form-control" id="exampleFormControlSelect1" @change="GetResourceSelects">
							<option value="">-- 请选择所属资源 --</option>
							<option v-for="(item, index) in rtlist" :key="item.RT_GUID" :label="item.RT_ResourceTitle" :value="item.RT_GUID">{{ item.RT_ResourceTitle }}</option>
						</select>
					</div>
				</label>

				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">封面图片</p>
						<!-- baseurl :auto-upload="false"  class="upload-demo"  drag-->
						<el-upload
							list-type="picture-card"
							:action="baseurl1"
							accept=".jpg, .png"
							:file-list="filelists"
							:limit="1"
							multiple
							:on-change="changefile"
							:before-upload="fmbeforeUpload"
							:on-success="successloadpic"
							:headers="{ Authorization: token }"
						>
							<i class="el-icon-plus"></i>
							<!-- <div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
							</div> -->
							<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload>
					</div>
				</div>
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
							上传资源
							<span style="color: red;">*</span>
						</p>

						<div v-loading="idlodings">
							<el-upload
								class="upload-demo"
								:action="baseurl1"
								ref="upload"
								drag
								:headers="{ Authorization: token }"
								:limit="1"
								:file-list="filelistszy"
								:before-upload="beforechangefilezy"
								:on-change="changefilezy"
								:on-success="successloadzy"
								:accept="zyaccept"
								:on-exceed="exceeds"
								:on-progress="progresszy"
							>
								<!-- :show-file-list="false" :auto-upload="false" -->
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									将文件拖到此处，或
									<em>点击上传</em>
									&nbsp;
									<i style="color: red;">{{ contengtuplod }}</i>
								</div>
							</el-upload>
						</div>
					</div>
				</div>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-6 col-md-4 col-lg-2">
							资源权限
							<span style="color: red;">*</span>
						</p>
						<div class="radioszyqx">
							<el-radio v-model="radio" label="0">全网公开（所有登录用户）</el-radio>
							<el-radio v-model="radio" label="1">只对本院校公开</el-radio>
							<el-radio v-model="radio" label="2">全网公开（游客、非注册用户）</el-radio>
							<el-radio v-model="radio" label="3">私有</el-radio>
						</div>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">资源描述</p>
						<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10 }" placeholder="请输入资源描述" v-model="textarea2"></el-input>
					</div>
				</label>
			</form>
			<div class="fromsbtn col-xs-12 col-sm-10 col-md-8 col-lg-8">
				<button :disabled="idlodings" @click="addtrainroom()" v-preventReClick>提交</button>
				<button @click="resovestrainroom()">重置</button>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { UpdateResourcea, UploadFileAsync, getGetProfList, getPositionList, getGetResourceTypes, AddResourcesource } from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import { setbaseurl } from '@/utils/utils.js';

import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			contengtuplod: '请选择资源类型',
			videoForm: {
				showVideoPath: ''
			},
			zyaccept: '',
			// 标题
			paths: [
				{
					path: '/resource/uploadresour',
					name: '上传资源'
				}
			],
			resourceobj: {
				RT_GUID: '',
				ProfessionalID: '',
				PR_GUID: '',
				ResourceName: '',
				name: ''
			},
			zyllist: [],
			radio: '0',
			textarea2: '',
			// 获取专业、岗位、资源类型列表
			prolist: [],
			polist: [],
			rtlist: [],
			filelists: [],
			filelistszy: [],
			zyfiles: '', //accept
			baseurl: '',
			token: 'Bearer ' + localStorage.getItem('token'),
			fileobj: {
				url: ''
			},
			baseurl1: setbaseurl() + '/Courses/UploadFileAsync',
			filepicobj: {
				url: '',
				filename: ''
			},
			fileSuffix: '',
			isedit: 0,
			ilguid: '',
			// 进度调
			loadProgress: 0, // 动态显示进度条
			progressFlag: false, // 关闭进度条
			isvideo: true,
			// 资源对象
			filezyobjs: {},
			idlodings: false,
			sizes: ''
		};
	},
	mounted() {
		this.baseurl = setbaseurl() + '/TrainPower/UploadImages';
		this.baseurl1 = setbaseurl() + '/Courses/UploadFileAsync';
		this.get();
		let resources = window.localStorage.getItem('resources');

		if (resources) {
			let resourcesa = JSON.parse(window.localStorage.getItem('resources'));

			this.resourceobj.name = resourcesa.LR_Title;
			this.resourceobj.RT_GUID = resourcesa.LR_ResourceType_Tag;

			this.resourceobj.ProfessionalID = resourcesa.pro_guid ?? '';

			if (resourcesa.pro_guid) {
				this.getpolist();
			}
			this.filelistszy = [
				{
					name: resourcesa.LR_FileName,
					url: resourcesa.LR_OriginalFileUrl
				}
			];

			this.filelists = [
				{
					name: resourcesa.LR_FileName,
					url: resourcesa.LR_SurfacePlotUrl
				}
			];
			this.zyaccept = this.LR_FileSuffix;
			this.resourceobj.PR_GUID = resourcesa.LR_ProfessionalName_Tag;
			this.textarea2 = resourcesa.LR_Describe ?? '';
			this.fileSuffix = resourcesa.LR_FileSuffix;
			this.fileobj.url = resourcesa.LR_OriginalFileUrl;
			this.fileobj.filename = resourcesa.LR_FileName;
			this.filepicobj.url = resourcesa.LR_SurfacePlotUrl;
			this.filepicobj.filename = resourcesa.LR_FileName;
			this.filepicobj.LR_FileSize = resourcesa.LR_FileSize;
			this.radio = resourcesa.LR_Privilage;
			this.ilguid = resourcesa.LR_GUID;
			this.isedit = 1;
		}
	},
	destroyed() {
		window.localStorage.removeItem('resources');
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		resovestrainroom() {
			Object.assign(this.$data, this.$options.data());
			this.get();
		},
		get() {
			this.getprolist();
			this.getResourceType();
		},
		addtrainroom() {
			// console.log(this.fileobj)
			let fileSuffix = '';
			let LR_FileSize = '';
			// console.log(this.filepicobj)
			if (this.filepicobj.filename != '') {
				fileSuffix = this.fileSuffix;

				LR_FileSize = this.filepicobj.LR_FileSize;

				// this.filepicobj.filename.substring(this.filepicobj.filename.lastIndexOf('.'));
			} else {
				fileSuffix = this.fileobj.filename.substring(this.fileobj.filename.lastIndexOf('.'));
				fileSuffix = fileSuffix.indexOf('.') !== -1 ? fileSuffix.slice(1, fileSuffix.length) : fileSuffix;
				LR_FileSize = this.sizes;
			}

			if (fileSuffix == 0) {
				if (this.fileobj.filename.indexOf('.') !== -1) {
					var index = this.fileobj.filename.lastIndexOf('.');
					fileSuffix = this.fileobj.filename.substring(index + 1);
				}
			}

			// console.log(fileSuffix,this.filepicobj.filename)

			let Self = this;

			if (this.resourceobj.name == '') {
				this.$message('请输入资源名');
				return;
			}
			if (this.resourceobj.RT_GUID == '') {
				this.$message('请选择类型');
				return;
			}
			if (this.resourceobj.ProfessionalID == '') {
				this.$message('请选择专业');
				return;
			}
			if (this.resourceobj.PR_GUID == '') {
				this.$message('请选择岗位');
				return;
			}

			let ressour = {
				LR_Title: this.resourceobj.name,
				LR_ResourceType_Tag: this.resourceobj.RT_GUID,
				LR_ProfessionalName_Tag: this.resourceobj.PR_GUID,
				LR_NewFileUrl: this.fileobj.url,
				LR_Privilage: this.radio,
				LR_FileName: this.fileobj.filename,
				LR_Describe: this.textarea2,
				LR_SurfacePlotUrl: this.filepicobj.url,
				LR_FileSuffix: fileSuffix,
				LR_GUID: '',
				LR_FileSize: LR_FileSize
			};
			// this.fileSuffix.slice(1, this.fileSuffix.length)

			if (this.isedit == 1) {
				ressour.LR_GUID = this.ilguid;
				UpdateResourcea(ressour).then(res => {
					if (res.data.code > 0) {
						Self.$message.success(res.data.msg);
						this.resourceobj.RT_GUID = '';
						this.resourceobj.ProfessionalID = '';
						this.textarea2 = '';
						this.resourceobj.name = '';
						this.radio = '0';
						this.filelists = [];
						this.filelistszy = [];
						this.$refs.upload.clearFiles();
						this.resourceobj.PR_GUID = '';
						this.$router.go(-1);
					}
				});
			} else {
				AddResourcesource(ressour).then(res => {
					if (res.data.code > 0) {
						Self.$message.success(res.data.msg);
						this.resourceobj.RT_GUID = '';
						this.resourceobj.ProfessionalID = '';
						this.textarea2 = '';
						this.resourceobj.name = '';
						this.radio = '0';
						this.filelists = [];
						this.filelistszy = [];
						this.$refs.upload.clearFiles();
						this.resourceobj.PR_GUID = '';
					}
				});
			}

			// resourceobj.PR_GUID
		},
		// 进度
		progresszy(event, file, fileList) {
			// console.log(event, '进度');
		},
		beforechangefilezy() {},
		changefile(e) {
			// console.log(e, '获取图片文件');
			// this.fmbeforeUpload(e)
		},
		changefilezy(file, fileList) {
			if (this.resourceobj.RT_GUID == '') {
				this.$message('请选择资源类型');
				this.$refs.upload.clearFiles();
				// console.log(this.filelistszy,fileList)
			} else {
				this.beforeuploadzy(file);
			}
		},
		exceeds(files, fileList) {
			this.filelistszy = [];
		},
		beforeuploadzy(file) {
			const fileSuffix = file.name.substring(file.name.lastIndexOf('.'));
			const whiteList = this.zyaccept.split(',');

			if (whiteList.indexOf(fileSuffix) === -1) {
				this.$message('上传文件只能是' + this.zyaccept + '格式');
				return false;
			}
			// console.log(e, '资源上传之前');
			const isLt2M = file.size / 1024 / 1024 < 1100;
			if (!isLt2M) {
				this.$message('上传文件大小不能超过 1.1g');
				return false;
			}
			// console.log(this.fileobj.url =='')
			if (this.fileobj.url == '') {
				this.idlodings = true;
			}
			// this.filezyobjs = file;
			// this.filezyobjs.type = 'ship';
		},
		// 上传资源成功
		successloadzy(response, file, fileList) {
			// console.log(file, '成功',response);
			this.fileobj = response.data;
			this.filelistszy = fileList;
			this.sizes = file.size / 1024;
			this.idlodings = false;
		},
		successloadpic(file) {
			this.filepicobj = file.data;
		},
		// 上传图片之前
		fmbeforeUpload(file) {
			const fileSuffix = file.name.substring(file.name.lastIndexOf('.'));

			const whiteList = ['.jpg', '.png'];
			if (whiteList.indexOf(fileSuffix) === -1) {
				this.$message('上传文件只能是 jpg、png格式');
				return;
			}

			const isLt2M = file.size / 1024 / 1024 < 10;

			if (!isLt2M) {
				this.$message('上传文件大小不能超过 10mb');
				return;
			}
		},
		// 资源类型
		GetResourceSelects() {
			let nameobj = this.rtlist.filter(ite => ite.RT_GUID == this.resourceobj.RT_GUID)[0];
			this.$refs.upload.clearFiles();
			// console.log(nameobj.RT_ResourceTitle,"title")
			if (nameobj.RT_ResourceTitle == '视频') {
				this.contengtuplod = '请上传视频类型的文件,.mp4等类型';
				this.zyaccept = '.ogg,.mp4,.flv';
				this.isvideo = false;
			} else if (nameobj.RT_ResourceTitle == '文本') {
				this.contengtuplod = '请上传文本类型的文件,.pdf等类型';
				this.zyaccept = '.pdf';
				this.isvideo = true;
			} else if (nameobj.RT_ResourceTitle == '图片') {
				this.contengtuplod = '请上传图片类型的文件,.jpg.png等类型';
				this.zyaccept = '.jpg,.png,.svg';
				this.isvideo = true;
				// console.log('图片')
			} else {
				this.contengtuplod = '请上传虚拟类型的文件,.html等类型';
				this.zyaccept = '.html';
				this.isvideo = true;
			}
			this.idlodings = false;
		},
		GetuserSelects() {
			this.getprolist();
		},
		getprolist() {
			this.prolist = [];

			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						// console.log(this.prolist)
						if (this.resourceobj.ProfessionalID !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.resourceobj.ProfessionalID !== '') {
							this.getpolist();
						}
					}
				});
			}

			// getGetProfList().then(res => {
			// 	// console.log(res.data.data)
			// 	if (res.data.code > 0) {
			// 		this.prolist = res.data.data;
			// 		if (this.resourceobj.ProfessionalID !== '') {
			// 			this.getpolist();
			// 		}
			// 	}
			// });
		},
		getpolist() {
			getPositionList(this.resourceobj.ProfessionalID).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>
